import { MODAL_MIN_ZINDEX } from "config/constants"

let currentZIndex = MODAL_MIN_ZINDEX

export function getZIndex() {
    return ++currentZIndex
}
